/* global swiftCode:true */
/* eslint no-undef: "error" */

import axios from 'axios';
import { createHeadersForApiCall, purgeAuthenticationCookie } from './cookies';
import { BASE_URL } from '../constants';
import 'whatwg-fetch';
import { Mixpanel } from './Mixpanel';

export * from './api-calls/authentication-calls.js';
export * from './api-calls/user-calls.js';
export * from './api-calls/employee-interaction-calls.js';
export * from './api-calls/shift-calls.js';
export * from './api-calls/location-calls.js';
export * from './api-calls/calendar-shift-calls';
export * from './api-calls/comments.js';

export const publicAxiosInstance = axios.create({
  baseURL: `${BASE_URL}`,
  params: {
    'response[put_return_resource]': 'true',
    'response[nested]': 2,
  },
});

export const protectedAxiosInstance = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    common: createHeadersForApiCall(),
  },
  params: {
    'response[put_return_resource]': 'true',
    'response[nested]': 2,
  },
});


export const singleLevelProtectedAxiosInstance = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    common: createHeadersForApiCall(),
  },
  params: {
    'response[put_return_resource]': 'true',
    'response[nested]': 1,
  },
});

export const zeroParamProtectedAxiosInstance = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    common: createHeadersForApiCall(),
  },
  params: {'response[put_return_resource]': 'true'}
});

export const axiosInstance = axios.create({
  baseURL: `${BASE_URL}`,
  params: {
    'response[put_return_resource]': 'true',
    'response[nested]': 2,
  },
});

// Add request interceptor to dynamically read cookies on each request
// This ensures session-uukey and other auth headers are always up-to-date
const addAuthHeadersInterceptor = (config) => {
  const headers = createHeadersForApiCall();
  // Merge dynamically read headers into the request config
  Object.keys(headers).forEach((key) => {
    if (headers[key]) {
      config.headers[key] = headers[key];
    }
  });
  return config;
};

protectedAxiosInstance.interceptors.request.use(addAuthHeadersInterceptor);
singleLevelProtectedAxiosInstance.interceptors.request.use(addAuthHeadersInterceptor);
zeroParamProtectedAxiosInstance.interceptors.request.use(addAuthHeadersInterceptor);

// unauthenticated handling
protectedAxiosInstance.interceptors.response.use(
  (response) => {
    // great!
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      Mixpanel.track('401 Error', { 'error': error });
        console.log('api-calls -> purgeAuthenticationCookie()')
      purgeAuthenticationCookie();
      window.location.pathname = '/login';
    }

    return Promise.reject(error);
  }
);

export const AddAuthHeaders = () => {
  const headers = createHeadersForApiCall();

  Object.keys(headers).map((key) => {
    protectedAxiosInstance.defaults.headers.common[key] = headers[key];
  });
};

export const GetLocation = (swiftCode) => {
  return fetch(`${BASE_URL}/api/organization/locations/${swiftCode}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((response) => response.json());
};
